<template>
    <modal name="login-popup"
           :width="500"
           :height="'auto'"

           class="visible"
           @before-open="beforeOpen"
           @before-close="beforeClose"
           @opened="afterOpen"
           :clickToClose="click_to_close"
           :adaptive="true"
           :shiftY="0.5"
           v-cloak>
        <div class="account-popup signon-prompt-popup">

            <span @click="$modal.hide('login-popup')" class="close-popup new-close-icon">
                <i class="la la-close"></i>
                <span class="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"/></svg>
                </span>
            </span>

            
            <div class="text-start" v-if="isLoginPath">
                <a :href="homeLink" class="home-link-popup"><i class="fa fa-chevron-left" style="font-size: 14px;"></i> Home</a>
            </div>

            <h3 class="popup-title">Login</h3>

            <div class="main-subtitle">
                Non hai un account? 
                <a href="javascript:void(0);" @click="handleRegistratiClick" style="cursor: pointer;">Registrati</a>
            </div>


            <!-- <span>Accedi al portale tramite login e password</span> -->
            <span class="errorMsg">{{ this.errorMsg }}</span>



            <!-- Text above form -->
            <div class="login-info-text" style="color: #FFC000; padding: 15px 0;">
                <span>Se eri un utente esistente di Tennisprofy, puoi usare la stessa Email e Password qui. Se non sei sicuro o non te li ricordi, vai a password dimenticata.</span>
            </div>

            <form v-on:submit.prevent="onSubmit">
                <div class="field-wrapper">
                    <!-- <div class="cfield">
                        <input type="text" placeholder="Email" v-model="user.email" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors"/>
                        <i class="la la-user"></i>
                    </div> -->

                    <div class="pf-field user-email-field">
                        <div class="pf-field floating-label-input" :class="{'error': this.errors['email']}">
                            <input type="text" placeholder=""  ref="useremail" name="useremail" id="useremail" v-model="user.email"  v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors"/>
                            <label class="floating-label" for="useremail">Email</label>
                            
                        </div>
                    </div>

                    <span class="error-msg-wrapper" style="min-height: 35px;">
                        <span class="error-msg" v-if="errors.email">{{ errors.email }}</span>
                    </span>


                </div>
                <div class="field-wrapper">
                    <!-- <div class="cfield">
                        <input type="password" placeholder="Password" v-model="user.password" v-on:focus="clearErrors" v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors" />
                        <i class="la la-key"></i>
                    </div> -->
                    <div class="pf-field user-email-field">
                        <div class="pf-field floating-label-input" :class="{'error': this.errors['password']}">
                            <input :type="!showPassword ? 'password' : 'text'" placeholder="" name="userpassword" id="userpassword" v-model="user.password"  v-on:blur="clearErrors"  v-on:change="clearErrors" v-on:keyup="clearErrors" />
                            <label class="floating-label" for="userpassword">Password</label>
                        </div>
                    </div>
                    
                    <span class="error-msg-wrapper no-height-error">
                        <span class="error-msg" v-if="errors.password">{{ errors.password }}</span>
                    </span>

                    <div class="show-password-wrapper py-2 mb-4">
                        <div class="show-pw-check">
                            <p class="remember-label">
                                <input type="checkbox" name="showpassword" value="1" id="showpassword" v-model="showPassword"><label for="showpassword">Mostra password</label>
                            </p>
                        </div>
                    </div>
                    
                    
                </div>

                <p class="remember-label">
                    <input type="checkbox" name="remember" value="1" id="remember" v-model="user.remember"><label for="remember">Rimani connesso</label>
                </p>
                <div class="forgot-password-wrapper">
                    <a :href="pwdResetLink" title="" class="forgot-pasword">Password dimenticata?</a>
                </div>
                <button type="submit" class="signin-submit-btn" :disabled="(formSaving || is_errors) ? true : null" :class="{'btn-in-progress': formSaving, 'btn-processed': formSaved  }">
                    <span>Login</span>
                </button>

                

            </form>
        </div>
    </modal>
</template>

<script>
    export default {
        name: "login-popup",
        props: {
            click_to_close: true,
            redirect_url: undefined,
        },


        data () {
            return {
                user: {email: "", password: "", remember: false},
                errorMsg: "",
                forceReload: false,
                urlToGo: null,
                errors: {
                    email: false,
                    password: false,
                },

                emailValidated: false,
                passwordValidated: false,
                
                formSaving: false,
                formSaved: false,
                is_errors: false,
                showPassword: false,
            }
        },
        computed: {
            isLoginPath() {
                return window.location.pathname.includes('/login');
            },
            
            homeLink(){
                let homeurl = import.meta.env.VITE_APP_URL;
                return homeurl;
            },
            pwdResetLink() {
                let appCallUrl = import.meta.env.VITE_APP_URL;
                return appCallUrl+'/password/reset';
            }
        },
        methods: {
            focusInput() {
                this.$refs.useremail.focus();
            },
            handleRegistratiClick(event) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                this.openSignupPopup();
            },
            openSignupPopup(){
                let _this = this;

                _this.$modal.hide('login-popup');
                
                setTimeout(() => {
                    _this.$modal.show('registration-modal');
                }, 300);
                
            },


            clearErrors( $event = {} ){

                const regexEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                const regexPassword = /^(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|\\;:,.<>/?`~]{8,20}$/;

                this.$forceUpdate();


                let emailValidated = regexEmail.test(this.user.email);
                let passwordValidated = regexPassword.test(this.user.password);

                if ( $event?.type == 'change' || ($event?.type == 'keyup' && ['Tab'].indexOf( $event?.key ) < 0 ) || $event?.type == 'blur' ) {

                    // Validate email
                    if ( $event.target.name == 'useremail' ) {
                        if ( this.user.email && !emailValidated || this.user.email == '' ) {
                            this.errors['email'] = "Inserisci una email valida";
                        } else {
                            this.errors['email'] = false;
                        }
                    } 


                    if ( $event.target.name == 'userpassword' ) {
                        if ( this.user.password && !passwordValidated || this.user.password == '' ) {
                            this.errors['password'] = "Almeno una lettera, almeno un numero, min 8 e max 20 caratteri";
                        } else {
                            this.errors['password'] = false;
                        }
                    }
                    

                } else {
                    // Validate email
                    if ( this.user.email && !emailValidated || this.user.email == '' ) {
                        this.errors['email'] = "Inserisci una email valida";
                    } else {
                        this.errors['email'] = false;
                    }


                    // Validate password
                    
                    if ( this.user.password && !passwordValidated || this.user.password == '' ) {
                        this.errors['password'] = "Almeno una lettera, almeno un numero, min 8 e max 20 caratteri";
                    } else {
                        this.errors['password'] = false;
                    }
                }



                //
                

  
                for (var k in this.errors) {
                    if (this.errors[k]) {
                        this.is_errors = true;
                        // window.scroll(0, 0);
                        return
                    }
                    this.is_errors = false;
                }




            },


            onSubmit() {


                this.clearErrors();

                if ( this.formSaving ) {
                    return 0;
                }   

                if ( this.is_errors ) {
                    // alert('Show errors');
                    return 0;
                }

                this.formSaving = true; 

                 

                const intended = window.location.pathname + window.location.search;

                this.$apiClient.doPostLogin(this.user.email, this.user.password, this.user.remember, intended).then(response => {
                    var data = response.data;
                    
                    if (data && data.status_code == 200) {

                        var responseData = data.data;

                        // Simply remember the last opened ad id
                        const customEvent = new CustomEvent('rememberOpenedId', { detail: {} });
                        document.dispatchEvent(customEvent);


                        this.formSaving = false; 
                        this.formSaved = true; 

                        // Successful login
                        if (typeof gtag === "function") {
                            gtag("event", "login", {
                                method: "Website"
                            });
                        }

                        if ( this.redirect_url ) {
                            
                            window.location = this.redirect_url;

                        } else {
                            if (this.urlToGo != null) {
                                window.location = this.urlToGo;
                            } else if (this.forceReload) {
                                window.location.reload();
                            } else {
                                
                                if (responseData.redirect == true) {
                                    window.location = responseData.path
                                } else {
                                    window.location.reload();
                                }
                            }
                        }
                    } else {
                        this.errorMsg = "Email o password non valide. Riprova.";
                    }
                }).catch(error => {
                    // The global Axios interceptor (bootstrap.js) already
                    // redirected to /re-consent for this response and tagged
                    // the error — do not show an "invalid credentials"
                    // message while that redirect is in flight.
                    if (error.isReconsentRequired) {
                        return;
                    }

                    console.log('errorresponse: ', error);
                    this.errorMsg = "Email o password non valide. Riprova.";
                    this.formSaving = false;
                    let containsError = false;



                    if ( error.response?.data?.errors ) {
                        if ( error.response?.data?.errors?.email.length ) {
                            containsError = true;
                        }
                        if ( error.response?.data?.errors?.password?.length ) {
                            containsError = true;
                        }
                    }

                    if ( containsError ) {
                        this.errorMsg = "Email o password non valide. Riprova.";
                    } else {
                        alert("Hai effettuato il logout. Riprova.");
                        window.location.reload(); 
                    }

                    

                })
            },
            beforeClose(event) {
                $('html').removeClass('no-scroll');
                this.forceReload = false;
                this.urlToGo = null;
            },

            afterOpen() {
                
                console.log('afterr open running: 1');
                this.focusInput();
            },

            beforeOpen(event) {
                console.log('before open: ', event);
                $('html').addClass('no-scroll');
                this.errors = {};
                this.errorMsg = "";


                if (event.params) {
                    this.forceReload = event.params.forceReload;
                    this.urlToGo = event.params.urlToGo;

                    if ( event.params.redirect_url ) {
                        console.log(  event.params.redirect_url );
                        this.urlToGo = this.redirect_url;
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .visible {
        display: block;
    }
</style>